import {
  CHECK_CAN_CREATE_TRIAL_JOB_PARAMS,
  CREATE_ADJUSTMENT_SURCHARGE_PAYLOAD,
  GET_ADJUSTMENT_SURCHARGE_PARAMS,
  JOB_TRANSACTION_PARAMS_REQUEST,
  PayloadActionData,
  UPDATE_ADJUSTMENT_SURCHARGE_PAYLOAD,
} from 'models';

export const GET_JOBS_LIST_REQUEST: string = 'GET_JOBS_LIST_REQUEST';

export const GET_JOBS_LIST_REQUEST_WITH_KEYWORD: string =
  'GET_JOBS_LIST_REQUEST_WITH_KEYWORD';

export const GET_JOBS_DETAIL_REQUEST: string = 'GET_JOBS_DETAIL_REQUEST';
export const DELETE_JOBS_REQUEST: string = 'DELETE_JOBS_REQUEST';
export const DELETE_ALL_JOBS_REQUEST: string = 'DELETE_ALL_JOBS_REQUEST';
export const GET_JOB_TRANSACTIONS_REQUEST: string =
  'GET_JOB_TRANSACTIONS_REQUEST';
export const CHECK_CAN_CREATE_TRIAL_JOB: string = 'CHECK_CAN_CREATE_TRIAL_JOB';
export const GET_ADJUSTMENT_SURCHARGE_REQUEST: string =
  'GET_ADJUSTMENT_SURCHARGE_REQUEST';
export const UPDATE_ADJUSTMENT_SURCHARGE_REQUEST: string =
  'UPDATE_ADJUSTMENT_SURCHARGE_REQUEST';
export const CREATE_ADJUSTMENT_SURCHARGE_REQUEST: string =
  'CREATE_ADJUSTMENT_SURCHARGE_REQUEST';
export const DELETE_ADJUSTMENT_SURCHARGE_REQUEST: string =
  'DELETE_ADJUSTMENT_SURCHARGE_REQUEST';

export const deleteJobRequest = (id: string, onSuccess?: () => void) => {
  return {
    type: DELETE_JOBS_REQUEST,
    payload: {
      id,
      onSuccess,
    },
  };
};

export const getJobsDetailAction = (
  payload: PayloadActionData<{ id: string }>
) => {
  return {
    type: GET_JOBS_DETAIL_REQUEST,
    payload,
  };
};

export const getJobTransactionsRequest = (
  id: string,
  params?: JOB_TRANSACTION_PARAMS_REQUEST | null
) => {
  return {
    type: GET_JOB_TRANSACTIONS_REQUEST,
    payload: { params: { ...(params || {}), job_id: id } },
  };
};

export const checkCanCreateTrialJob = (
  params: CHECK_CAN_CREATE_TRIAL_JOB_PARAMS
) => {
  return {
    type: CHECK_CAN_CREATE_TRIAL_JOB,
    payload: { params },
  };
};

export const getAdjustmentSurchargeAction = (
  params: GET_ADJUSTMENT_SURCHARGE_PARAMS
) => {
  return {
    type: GET_ADJUSTMENT_SURCHARGE_REQUEST,
    payload: { params },
  };
};

export const createAdjustmentSurchargeAction = (
  payload: PayloadActionData<CREATE_ADJUSTMENT_SURCHARGE_PAYLOAD>
) => {
  return {
    type: CREATE_ADJUSTMENT_SURCHARGE_REQUEST,
    payload,
  };
};

export const updateAdjustmentSurchargeAction = (
  payload: PayloadActionData<UPDATE_ADJUSTMENT_SURCHARGE_PAYLOAD>
) => {
  return {
    type: UPDATE_ADJUSTMENT_SURCHARGE_REQUEST,
    payload,
  };
};

export const deleteAdjustmentSurchargeAction = (
  payload: PayloadActionData<{ adjId: string }>
) => {
  return {
    type: DELETE_ADJUSTMENT_SURCHARGE_REQUEST,
    payload,
  };
};
